const styles = theme => ({
  inputField: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      backgroundColor: '#fff',
    },
  },
  listGroup: {
    marginTop: 0,
    width: '440px',
  },
  select: {
    marginTop: '0!important',
  },
  copy: {
    color: '#015FFB',
  },
  textPrice: {
    color: 'var(--Color---Dark, #637381)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '22px',
  },
  infoDiv: {
    display: 'flex',
    gap: '4px',
  },

  formControlPayment: {
    width: '100%',
    minWidth: 120,
    '& .MuiSelect-root': {
      backgroundColor: '#fff',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
  },
  selectEmptyPayment: {
    marginTop: theme.spacing(2),
  },
  // Select dropdown menu styling
  paymentSelectMenu: {
    '& .MuiPaper-root': {
      maxHeight: 300,
      borderRadius: '8px',
      marginTop: '4px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    },
    '& .MuiMenuItem-root': {
      padding: '8px 12px',
      borderRadius: '6px',
      margin: '4px 8px',
      '&:hover': {
        backgroundColor: 'rgba(1, 95, 251, 0.08)',
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(1, 95, 251, 0.12)',
        '&:hover': {
          backgroundColor: 'rgba(1, 95, 251, 0.16)',
        },
      },
    },
  },

  stepsStyle: {},
  iframeStyle: {
    borderRadius: '12px',
  },

  stepZero_main: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  stepZero_main2: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  stepZero_main_title2: {
    display: 'flex',
    alignItems: 'center',
  },
  stepZero_main_title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  stepOne_main: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  stepOne_main_title: {
    display: 'flex',
    alignItems: 'center',
  },
  stepTwo_main: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  stepTwo_main_title: {
    display: 'flex',
    alignItems: 'center',
  },
  stepTwo_main_buttons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  stepOne_main_buttons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  stepTwo_main_completedDiv: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  root: {
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    padding: '8px',
    paddingBottom: 16,
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  okayButton: {
    width: '100%',
    height: '36px',
    boxShadow: 'none',
    backgroundColor: '#015FFB',
    color: '#fff',
  },
  paymentLinkTextfield: { marginTop: '8px', width: '440px' },
  shareViewCopyButton: {
    width: '440px',
  },
  fieldsContainer: {
    display: 'flex',
    gap: '16px',
    marginBottom: '16px',
    flexWrap: 'wrap',
  },
  fieldItem: {
    flex: '1 1 calc(33.333% - 16px)',
    minWidth: '200px',
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      bottom: '-5px',
    },
  },
})

export default styles
